<template>
    <div v-if="!item.hidden && item.belong+'' == isAdminMenu" class="menu-wrapper">
        <template v-if="hasOneShowingChild(item.children,item) && (!onlyOneChild.children||onlyOneChild.noShowingChildren)&&!item.alwaysShow">
            <app-link v-if="onlyOneChild.meta" :to="resolvePath(onlyOneChild.path)">
                <el-menu-item :index="resolvePath(onlyOneChild.path)" :class="{'submenu-title-noDropdown':!isNest}">
                    <item :icon="onlyOneChild.meta.icon||(item.meta&&item.meta.icon)" :title="onlyOneChild.meta.title" />
                </el-menu-item>
            </app-link>
        </template>
        <el-submenu v-else ref="subMenu" :index="resolvePath(item.path)" popper-append-to-body>
            <template slot="title">
                <item v-if="item.meta" :icon="item.meta && item.meta.icon" :title="item.meta.title" />
            </template>
            <sidebar-item
                v-for="(child,index) in item.children"
                :id="'menu'+item.path.substr(1)+index"
                :key="child.path"
                :is-nest="true"
                :item="child"
                :is-admin-menu="isAdminMenu"
                :base-path="resolvePath(child.path)"
                class="nest-menu" />
        </el-submenu>
    </div>
</template>

<script>
import AppLink from './Link';
import FixiOSBug from './FixiOSBug';
import formReg from "@/utils/formReg";
import Item from './Item';
import path from 'path';
export default {
    name: 'SidebarItem',
    components: { Item, AppLink },
    mixins: [FixiOSBug],
    props: {
    // route object
        item: {
            type: Object,
            required: true
        },
        isNest: {
            type: Boolean,
            default: false
        },
        isAdminMenu: {
            type: String,
            default: "home"
        },
        basePath: {
            type: String,
            default: ''
        }
    },
    data() {
        // To fix https://github.com/PanJiaChen/vue-admin-template/issues/237
        // TODO: refactor with render function
        this.onlyOneChild = null;
        return {};
    },
    methods: {
        getAdmin() {
            console.log();
        },
        hasOneShowingChild(children = [], parent) {
            const showingChildren = children.filter(item => {
                if(item.hidden) {
                    return false;
                }else {
                    // Temp set(will be used if only has one showing child)
                    this.onlyOneChild = item;
                    return true;
                }
            });

            // When there is only one child router, the child router is displayed by default
            if(showingChildren.length === 1) {
                return true;
            }

            // Show parent if there are no child router to display
            if(showingChildren.length === 0) {
                this.onlyOneChild = { ... parent, path: '', noShowingChildren: true };
                return true;
            }

            return false;
        },
        resolvePath(routePath) {
            if(formReg.isExternal(routePath)) {
                return routePath;
            }
            if(formReg.isExternal(this.basePath)) {
                return this.basePath;
            }
            const currentPath = path.resolve(this.basePath, routePath);
            return currentPath;
        }
    }
};
</script>

<style lang="scss" scoped>
::v-deep .el-menu,.el-menu--inline{
    position: static;
}
</style>
